import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { portalGradientTextSx } from '../../styles/dashboardBrand';

const AdminPageWrapper = ({ title, children, subtitle }) => {
  return (
    <Box sx={{ p: { xs: 2, sm: 4 } }}>
      <Box sx={{ mb: 3, animation: 'fadeInUp 0.6s ease-out' }}>
        <Typography
          variant="h4"
          sx={portalGradientTextSx({
            fontWeight: 700,
            mb: subtitle ? 1 : 2,
          })}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography 
            variant="body1" 
            color="text.secondary" 
            sx={{ 
              mb: 3,
              fontSize: '1.1rem',
              fontWeight: 500,
            }}
          >
            {subtitle}
          </Typography>
        )}
      </Box>
      <Box
        sx={{
          position: 'relative',
          animation: 'fadeInUp 0.8s ease-out 0.2s both',
        }}
      >
        {children}
      </Box>
      
      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </Box>
  );
};

export default AdminPageWrapper;
